import vue from 'vue';
import VueI18n from 'vue-i18n';
import axios from 'axios';

vue.use(VueI18n);

export const I18n = new VueI18n({
  fallbackLocale: 'en_US',
});

window.VueI18n = I18n;
const loadedLanguages = [];

function setI18nLanguage(lang) {
  // Change locale language for vue-i18n
  I18n.locale = lang;
  // Setting HTTP header for natural language and locale
  axios.defaults.headers.common['Accept-Language'] = lang;
  // Set 'lang' attribute on webpage's html tag
  document.querySelector('html').setAttribute('lang', lang);
  return lang;
}

// function for Lazy loading or asynchronously loading the translation files
export async function loadLanguageAsync(lang) {
  // If invoked for the same language as I18n locale
  if (I18n.locale === lang) {
    return Promise.resolve(setI18nLanguage(lang));
  }
  // If the language was already loaded
  if (loadedLanguages.includes(lang)) {
    return Promise.resolve(setI18nLanguage(lang));
  }
  // If the language hasn't been loaded yet
  return import(/* webpackChunkName: "lang-[request]" */ `@/lang/${lang}.json`).then((messages) => {
    I18n.setLocaleMessage(lang, messages.default);
    loadedLanguages.push(lang);
    return setI18nLanguage(lang);
  });
}

export default I18n;
